import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ responsive }) => {
  return {
    container: {
      width: '100%',
      marginInline: 'auto',
      paddingInline: 20,

      [responsive.md]: {
        paddingInline: 16
      }
    }
  }
})
